export default {
  async fetchMiners(context: any, isAsic: boolean) {
    //changed URL from ENV
    const url = isAsic
      ? `https://minerhost.eu/api/kalkulatorMiners/asic`
      : `https://minerhost.eu/api/kalkulatorMiners/gpu`;
    try {
      const response = await fetch(url);

      const responseData = await response.json();
      console.log(responseData);
      const miners: object[] = [];
      responseData.forEach((miner: any) => {
        miner = {
          id: isAsic ? miner.id : miner.id + 300,
          isAsic: isAsic ? true : false,
          name: miner.name,
          link: miner.link,
          power: Number(miner.power),
          algorithm: String(miner.algorithm),
          price: Number(miner.price),
          img: miner.img,
          hashrate: miner.hashrate,
          units: miner.units,
        };
        miners.push(miner);
      });
      if (miners.length < 1) {
        throw new Error("no miners defined");
      }
      isAsic
        ? context.commit("setAsicMiners", miners)
        : context.commit("setGpuMiners", miners);
      context.commit("calculateMinerRevenue", isAsic);
      context.commit("setMiners");

      setTimeout(function () {
        context.commit("removeCachedMinersRevenues");
      }, 60000);
      setTimeout(function () {
        context.commit("removeExchangeRate");
      }, 86400000);

      /* context.commit("setLoading", false); */
    } catch (error) {
      context.commit("setError", {
        error: error,
        errorDescription: "we are sorry content is unavailable!",
      });
      /* context.commit("setLoading", false); */
      console.log(error);
    }
  },
  async getMinersFromDB(context: any) {
    const url = `/kalkulator/dbCall.php`;

    return await fetch(url)
      .then((res) => res.json())
      .then((data) => context.commit("setDbMiners", data));
  },
  async getExchangeRate(context: any) {
    const url = `https://api.nbp.pl/api/exchangerates/rates/a/usd/last`;

    const localStorageExchangeRate = localStorage.getItem(`exchangeRate`);
    if (!localStorageExchangeRate) {
      return fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const exchangeRate = parseFloat(data.rates[0].mid);
          context.commit("setExchangeRate", exchangeRate);
          const dataToStore = JSON.stringify(exchangeRate);
          localStorage.setItem(`exchangeRate`, dataToStore);
        })
        .catch((error) => {
          console.error("Error retrieving exchange rate:", error);
          return null;
        });
    } else {
      context.commit("setExchangeRate", localStorageExchangeRate);
    }
  },
};
